import { Reveal } from "@/components/Reveal";
import { SectionParticles } from "@/components/SectionParticles";
import { SectionBg } from "@/components/SectionBg";
import { AccordionList } from "@/components/Accordion";
import { CAMPAIGN } from "@/lib/campaign";

const FAQS = [
  {
    title: "Is the workshop free?",
    body: "Yes. There is no attendance fee. If someone later chooses to pursue financing, ordinary loan and third-party costs may apply and will be disclosed through the applicable process.",
  },
  {
    title: "Is this a loan application?",
    body: "No. Registering for or attending the workshop does not constitute a loan application or a commitment to lend.",
  },
  {
    title: "Will attending affect my credit?",
    body: "No hard credit pull is required to register or attend the workshop.",
  },
  {
    title: "Who is this workshop for?",
    body: "People exploring VA home loan eligibility and a Florida primary-residence purchase, including first-time users, prior users, relocating households, and surviving spouses who may be eligible.",
  },
  {
    title: "What will be covered?",
    body: "The workshop covers eligibility and entitlement questions, buying-power inputs, potential cash categories, credit and document preparation, the VA purchase path, and how to choose a next step.",
  },
  {
    title: "Is it live or on demand?",
    body: `This is planned as a live session on ${CAMPAIGN.webinarDate} at ${CAMPAIGN.webinarTime} ${CAMPAIGN.webinarTimezone}.`,
  },
  {
    title: "What happens after I register?",
    body: "The registrant receives an event confirmation and reminders only according to the consent choices captured. After the workshop, an optional individual strategy session may be offered.",
  },
  {
    title: "Do I have to apply or speak with a mortgage professional?",
    body: "No. There is no obligation to apply or book a session. Individual guidance requires a separate conversation and, when appropriate, an application and supporting documentation.",
  },
];

/* SECTION 11 — FAQ */
export const FAQ = () => (
  <section id="faq" className="relative overflow-hidden px-5 md:px-10 lg:px-16 py-28 md:py-36 hairline-t" data-testid="faq-section">
    <SectionBg img="bg-home-2.jpg" strength={0.93} />
    <SectionParticles variant="keys" />
    <div className="relative z-10 max-w-4xl mx-auto text-left">
      <p className="font-mono text-[11px] tracking-[0.3em] text-[var(--muted)] mb-12">
        [008] — COMMON QUESTIONS
      </p>
      <Reveal>
        <AccordionList items={FAQS} testPrefix="faq-accordion" />
      </Reveal>
    </div>
  </section>
);
